<template>
	<div class="c-base-input-radio-buttons">
		<label
			v-for="(option, index) in options"
			:key="`field-${index}`"
			class="inline-flex items-center gap-x-xs cursor-pointer"
		>
			<input
				:id="`field-${index}`"
				ref="inputs"
				type="radio"
				v-bind="option"
				:value="option.value"
				:name="name"
				class="
					c-base-input-radio-buttons__input
					relative
					rounded-full
					w-22
					h-22
				"
				:checked="option.value === value"
				@change="$emit('input', $event.target.value)"
			/>
			<span
				class="font-darker-grotesque text-form-label font-semibold"
				v-text="option.label"
			></span>
		</label>
	</div>
</template>

<script>
export default {
	name: 'BaseInputRadioButtons',

	props: {
		value: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			required: true,
		},
		options: {
			type: Array,
			default: () => [],
			validator: (value) =>
				value.reduce((acc, cur) => acc && cur.value != null, true),
		},
	},
	watch: {
		value() {
			if (this.$refs.inputs) {
				this.$refs.inputs.forEach((element) => {
					element.checked = element.value === this.value;
				});
			}
		},
	},
};
</script>

<style lang="postcss">
.c-base-input-radio-buttons {
	@apply flex flex-wrap gap-x-md;
}
.c-base-input-radio-buttons__input {
	@apply bg-black border-black;
	border-width: 7px;
}
.c-base-input-radio-buttons__input:checked {
	@apply bg-white;
}
</style>
